// extracted by mini-css-extract-plugin
export default {"button":"CustomGoogleButton_button__7JThi"};